// client/src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBWu8UJ6XV6J2OnpULHwBNDtBoW5kRB7Ao",
  authDomain: "parivarweddingevents.web.app",      // ✅ use your new hosting domain
  projectId: "planoraa-f496c",                     // (project name stays same)
  storageBucket: "planoraa-f496c.appspot.com",     // ✅ correct bucket
  messagingSenderId: "951138511528",
  appId: "1:951138511528:web:5fc3ac2fe0ed76db76b09d",
  measurementId: "G-K1FVQHYGKV",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Core Firebase services
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
provider.setCustomParameters({ prompt: "select_account" });
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
